import { lazy } from "react";
import { Route, Switch } from "react-router-dom";

const LiveShoppingPage = lazy(() => import("../../pages/LiveShoppingPage"));

export function KristinYehRoutes() {
  return (
    <Switch>
      <Route path="/ky/live-shopping" component={LiveShoppingPage} />
    </Switch>
  );
}

export const slug = "ky";
